import { render, staticRenderFns } from "./CBSPaydirect.vue?vue&type=template&id=feb16324&"
import script from "./CBSPaydirect.vue?vue&type=script&lang=js&"
export * from "./CBSPaydirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports